module.exports = __webpack_public_path__ + "static/media/xalingo.69ef8daa.jpeg";